import { Download } from 'lucide-react';

/**
 * A field an event imported from FareHarbor never had. Dashed outline, an
 * import glyph and plain words, so it reads as historical absence: never as
 * still loading, and never as someone here having left it blank.
 */
export default function NotRecordedPill({
  field,
  short = false,
}: {
  field: string;
  short?: boolean;
}) {
  return (
    <span
      title={`${field} was not recorded in FareHarbor. Add it when the client confirms.`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: short ? '1px 7px' : '2px 8px',
        borderRadius: 999,
        border: '1px dashed var(--nb-border-2)',
        fontSize: short ? 10.5 : 11.5,
        fontWeight: 500,
        fontStyle: 'normal',
        color: 'var(--nb-subtle)',
        whiteSpace: 'nowrap',
      }}
    >
      <Download size={11} aria-hidden style={{ opacity: 0.7 }} />
      {short ? 'Not recorded' : 'Not recorded in FareHarbor'}
    </span>
  );
}
